<template>
    <div class="tab-container">
        <button class="label-xl content-1 " v-for="(tab, index) in tabs" :key="index"
            :class="{ active: isActive(tab.name), disabled: tab.disabled }" @click="!tab.disabled && navigate(tab.name)"
            :disabled="tab.disabled">
            {{ tab.label }}
        </button>
    </div>
</template>

<style scoped>
.tab-container {
    display: inline-flex;
    padding: 4px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: var(--border-radius-xl);
    background: var(--background-1);
}

button {
    display: flex;
    padding: 4px 24px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: var(--border-radius-xl);
    box-sizing: border-box;
    background: var(--background-1);
    border: 0px;
}

button:hover {
    background: var(--background-1);
    color: var(--semantic-highlight);

}

button.active {
    border-radius: var(--border-xl);
    background: var(--background-4);
    color: var(--semantic-highlight);
    border-radius: var(--border-radius-xl);
}

button:disabled {
    background: var(--background-disable);
    color: var(--content-disable);
    cursor: not-allowed;
}

@media screen and (max-width: 640px) {
    .tab-container {
        width: 100%;
    }

    button {
        width: 100%;
    }
}
</style>

<script>
export default {
    name: 'TabComponent',
    props: {
        tabs: {
            type: Array,
            required: true,
        },
        activeTab: {
            type: String,
            default: ''
        },
    },
    methods: {
        isActive(name) {
            return this.activeTab === name;
        },
        navigate(name) {
            this.$emit('tab-changed', name);
        },
    },
}
</script>